/**
 * The phone tab bar's icons: one set of thin line drawings on a 24px grid, drawn
 * in the text colour (currentColor), so they turn gold with the active tab.
 *
 * They replace emoji, which every phone draws differently and which clashed with
 * the dark-and-gold look. Each value is the inside of an <svg viewBox="0 0 24 24">;
 * the strings are fixed here, never built from user input.
 */
export const TAB_ICONS = {
  // A house — the member's own home page.
  home: '<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h5v-6h4v6h5V9.5"/>',
  // A temple front — the public homepage.
  temple: '<path d="M3 9h18L12 3.5Z"/><path d="M5.5 9v9M10 9v9M14 9v9M18.5 9v9"/><path d="M3.5 18.5h17M2.5 21h19"/>',
  // A flame — the community feed.
  feed: '<path d="M12 21c-3.9 0-6.5-2.6-6.5-6.2 0-3.4 2.4-5.5 3.8-8.3.4 1.9 1.4 3.1 2.6 3.7.2-2.6 1.4-5 3.6-6.7-.2 2.6.6 4.4 1.9 6.1 1 1.4 1.6 2.9 1.6 4.9 0 3.9-3 6.5-7 6.5Z"/><path d="M12 21c-1.6 0-2.8-1.1-2.8-2.7 0-1.5 1-2.5 2-3.7.3.9.8 1.5 1.5 1.8.4-.8.9-1.4 1.5-1.9.5 1 .9 1.9.9 3.2 0 1.9-1.4 3.3-3.1 3.3Z"/>',
  // Two people — the Circles.
  circles: '<circle cx="9" cy="8" r="3.2"/><path d="M3 19.5c.6-3.3 3-5.2 6-5.2s5.4 1.9 6 5.2"/><circle cx="16.5" cy="9" r="2.6"/><path d="M15.8 14.4c2.6.1 4.6 1.8 5.2 4.6"/>',
  // An envelope — the inbox.
  inbox: '<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="m3.5 7 8.5 6.2L20.5 7"/>',
  // A calendar page — events.
  events: '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/><path d="M8 14h.01M12 14h.01M16 14h.01M8 17.2h.01M12 17.2h.01"/>',
  // The ankh — joining the church.
  join: '<ellipse cx="12" cy="6.8" rx="3.6" ry="4.3"/><path d="M12 11.1v10.4M6 13.4h12"/>',
  // A person — the visitor's account.
  account: '<circle cx="12" cy="8" r="3.8"/><path d="M4.5 20.5c.9-4 3.9-6.3 7.5-6.3s6.6 2.3 7.5 6.3"/>',
  // An arrow through a door — sign in.
  signin: '<path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4"/><path d="M3.5 12H14M10 8l4 4-4 4"/>',
  // Three lines — the menu drawer.
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
};

/** The full <svg> for one icon, or '' if the name is unknown. */
export function tabIconSvg(name) {
  const body = TAB_ICONS[name];
  if (!body) return '';
  return `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" focusable="false">${body}</svg>`;
}
